export const SET_RANGE_TYPE = 'artful-client/DateRange/SET_RANGE_TYPE';
export const SET_LOCALE = 'artful-client/DateRange/SET_LOCALE';

export const INCREMENT = 'artful-client/DateRange/INCREMENT';
export const DECREMENT = 'artful-client/DateRange/DECREMENT';

export const SET_SYNC_TOKEN = 'artful-client/DateRange/SET_SYNC_TOKEN';
export const CLEAR_SYNC_TOKEN = 'artful-client/DateRange/CLEAR_SYNC_TOKEN';
